import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FnFileUploadComponent } from './fn-files-upload-component';
import { FnFileActionUiComponent } from './fn-file-action-ui/fn-file-action-ui.component';
export * from './fn-files-upload-component';
export * from './fn-file-action-ui/fn-file-action-ui.component';
export * from './fn-file-action-ui/fn-cloud-file.model';
/**
 * Exports the required FnImgUploadModule to create a component that is used to upload image and show image on UI.
 * making them available for import by NgModules that import this module.
 */

@NgModule({
	declarations: [FnFileUploadComponent, FnFileActionUiComponent],
	imports: [CommonModule],
	exports: [FnFileUploadComponent, FnFileActionUiComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FnFilesUploadModule {}
